import { Dispatch, SetStateAction } from "react";
import { FormattedMessage } from "react-intl";

import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";

import { NextModalFooter } from "./NextModalFooter";

export function ConfirmNextModal({
  isOpen,
  handleNextClick,
  setIsOpenedConfirmationModal,
}: {
  isOpen: boolean;
  handleNextClick: (isConfirmed?: boolean) => void;
  setIsOpenedConfirmationModal: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <BasicModal
      autoHeight
      handleCancel={() => setIsOpenedConfirmationModal(false)}
      isModalOpen={isOpen}
      footer={
        <NextModalFooter
          handleOk={async () => {
            await handleNextClick(true);
            setIsOpenedConfirmationModal(false);
          }}
          handleCancel={() => setIsOpenedConfirmationModal(false)}
        />
      }
    >
      <>
        <p>
          <FormattedMessage
            id="candidate.taking.confirmNext.unansweredWarning"
            defaultMessage="You have unanswered questions on this page and you won't be able to go back to them."
          />
        </p>
        <p />
        <p>
          <FormattedMessage
            id="candidate.taking.confirmNext.confirmPrompt"
            defaultMessage="Are you sure you want to go to the next page?"
          />
        </p>
      </>
    </BasicModal>
  );
}
